export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
export const GET_FETCH_DATA = 'GET_FETCH_DATA'
export const GET_GROUPS_DATA = 'GET_GROUPS_DATA'
export const GET_GROUP_USERS = 'GET_GROUP_USERS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
